import { createContext, useContext } from "react";

/** Which product surface hosts the editor (#11548 round 16).
 *
 * A **Document** (the Artifacts surface, the chat editor panel) is plain
 * text: AI changes its content through chat and agent runs, but the report
 * machinery — the inline Ask-Finpilot query boxes — does not belong in it.
 * The Reports product keeps the full report editor.
 *
 * Context rather than props because tiptap node views (QueryInputNode) have
 * no props path from the mounting surface.
 */
export const PlainDocumentContext = createContext<boolean>(false);

export const usePlainDocument = (): boolean => useContext(PlainDocumentContext);
